import { aC as a, aM as o } from "./StickyHeaderSkeleton-dac046bb.mjs";
import { w as n, A as e } from "./Header-dd25ab18.mjs";
function y(r) {
  const {
    lang: s
  } = a();
  return n({
    url: o(e.CLIENT_V1_MY_CATEGORY),
    queryKey: [e.CLIENT_V1_MY_CATEGORY, {
      lang: s
    }],
    options: {
      suspense: !1,
      useErrorBoundary: !1,
      ...r
    }
  });
}
export {
  y as u
};
